export const isLastRow = <T>(index: number, array: T[]): boolean =>
  index === array.length - 1;
